export enum ContactType {
    PHONE_NUMBER = 'PHONE_NUMBER',
    MESSAGE = 'MESSAGE',
    EMAIL = 'EMAIL',
    WHATS_APP = 'WHATS_APP',
    VIBER = 'VIBER'
}
